export const budgetApprovalsEndpoints = {
  getBudgetApprovalsCalculatedAssignees: { method: 'get', path: '/get/{requestId}/calculated-assignees' },
  getBudgetApprovalsGroupAssignees: { method: 'get', path: '/get/{requestId}/group-assignees' },
  getBudgetApprovalsThresholds: { method: 'get', path: '/get/thresholds' },
  insertBudgetApprovalsThreshold: { method: 'post', path: '/insert/thresholds' },
  updateBudgetApprovalsThreshold: { method: 'post', path: '/update/{id}/thresholds' },
  deleteBudgetApprovalsThreshold: { method: 'post', path: '/delete/thresholds' },
  uploadBudgetApprovalsGroupAssigneesV2: { method: 'post', path: '/groups/assignees/{groupId}/upload-v2' },
  getBudgetApprovalsGroups: { method: 'get', path: '/get/groups' },
  insertBudgetApprovalsGroup: { method: 'post', path: '/insert/groups' },
  updateBudgetApprovalsGroup: { method: 'post', path: '/update/{id}/groups' },
  deleteBudgetApprovalsGroup: { method: 'post', path: '/delete/groups' },
  insertBudgetApprovalsGroupAssignees: { method: 'post', path: '/insert/group-assignees' },
  updateBudgetApprovalsGroupAssignees: { method: 'post', path: '/update/{id}/group-assignees' },
  deleteBudgetApprovalsGroupAssignees: { method: 'post', path: '/delete/group-assignees' },
  getBudgetApprovalsGroupCustomCoreData: { method: 'get', path: '/get/groups/{groupId}/custom-core-data' },
  insertBudgetApprovalsGroupCustomCoreData: { method: 'post', path: '/insert/group-custom-core-data' },
  deleteBudgetApprovalsGroupCustomCoreData: { method: 'post', path: '/delete/group-custom-core-data' },
} as const
